module.exports = __webpack_public_path__ + "img/crop_info_back_left.35fc355d.png";